'use client';

import { useParams } from 'next/navigation';
import { useSuspenseQuery } from '@apollo/client/react';
import { makeStyles } from 'tss-react/mui';
import { groupPostsQuery } from '@/apollo/groups';
import PostList from '@/components/groups/post-list';
import MaterialLinkButton from '@/components/material-link-button';
import PostNotificationPreferenceToggle from '@/components/groups/post-notification-preference-toggle';
import SectionHeader from '@/components/section-header';

const useStyles = makeStyles()((theme) => ({
  headerCreateButton: {
    marginLeft: theme.spacing(1),
  },
}));

const GroupPostsPageClient = () => {
  const { slug } = useParams();
  const { classes } = useStyles();

  const { data } = useSuspenseQuery(groupPostsQuery, {
    variables: { slug }
  });
  const group = data?.group;

  return (
    <>
      <SectionHeader
        action={
          <div>
            <PostNotificationPreferenceToggle group={group} />
            {group.permissions.createPost && (
              <MaterialLinkButton
                href={`/groups/${group.slug}/posts/new`}
                color="primary"
                variant="contained"
                className={classes.headerCreateButton}
                size="small"
              >
                Add Post
              </MaterialLinkButton>
            )}
          </div>
        }
      >
        Discussion
      </SectionHeader>

      <PostList posts={group.posts} group={group} />
    </>
  );
};

export default GroupPostsPageClient;
